import { useEffect, useMemo, useState } from "react";
import { LANGS, type Lang, type TKey, translations } from "./translations";

const LS_KEY = "mytsl_lang_v1";

function isLang(x: string | null): x is Lang {
  return !!x && (LANGS as readonly string[]).includes(x);
}

function getInitialLang(): Lang {
  const saved = localStorage.getItem(LS_KEY);
  if (isLang(saved)) return saved;

  const nav = (navigator.language || "").toLowerCase();
  if (nav.startsWith("pl")) return "pl";
  if (nav.startsWith("de")) return "de";
  if (nav.startsWith("it")) return "it";
  if (nav.startsWith("fr")) return "fr";
  if (nav.startsWith("es")) return "es";
  if (nav.startsWith("ro")) return "ro";
  if (nav.startsWith("bg")) return "bg";
  if (nav.startsWith("hr")) return "hr";
  if (nav.startsWith("cs")) return "cs";
  if (nav.startsWith("sk")) return "sk";
  return "en";
}

export function useI18n() {
  const [lang, setLang] = useState<Lang>(() => getInitialLang());

  useEffect(() => {
    localStorage.setItem(LS_KEY, lang);
  }, [lang]);

  const t = useMemo(() => {
  const dict = translations as Record<Lang, Record<TKey, string>>;
  return (key: TKey) => dict[lang]?.[key] ?? dict.en[key];
}, [lang]);

  return { lang, setLang, t };
}
